import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../service/service.module';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { LocalstorageService } from '../../config/localstorage.service';
import { USER_CLIENT_TOKEN_INFO } from '@algomusinc/domain';

@Injectable({
  providedIn: 'root'
})
export class ChatHandlerService {
  connection: any;
  environment = EnvironmentService.environment;
  constructor(public http: HttpClient,
    public storage: LocalstorageService,
  ) {
  }

  createConnection() {
    this.connection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Information)
      .withUrl(this.environment.messagingChatHubUrl, { accessTokenFactory: () => this.storage.get(USER_CLIENT_TOKEN_INFO) })
      .build()
  }

  connect() {
    this.connection
      .start({
        withCredentials: false
      })
      .then(function () {
      })
      .catch(function (err: any) {
        return console.error();
      });
  }

  stop() {
    this.connection.stop()
      .then(function () {
      })
      .catch(function (err: any) {
        return console.error();
      });
  }

}
